import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-navy text-white" data-id="element-93">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-94">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-teal blur-3xl" data-id="element-95"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-amber blur-3xl" data-id="element-96"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-6xl" data-id="element-97">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-98">
          <div className="order-2 md:order-1" data-id="element-99">
            <FadeIn data-id="element-100">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal/20 text-teal-light text-sm font-medium mb-6 border border-teal/30" data-id="element-101">
                <ShieldCheck size={16} data-id="element-102" />
                <span data-id="element-103">Guía de Seguridad para Familias</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-104">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-105">
                ESCUDO DE CONFIANZA:{' '}
                <span className="text-amber" data-id="element-106">El Protocolo de 7 Días</span> para
                Blindar a tu Hijo contra el Bullying
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-107">
              <h2 className="text-lg md:text-xl text-gray-300 font-light leading-relaxed mb-8" data-id="element-108">
                Dale a tu hijo de 8-12 años las herramientas psicológicas y
                verbales para neutralizar a los acosadores y recuperar su
                sonrisa en solo una semana.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-109">
              <a href="https://www.auriadigitalstore.com/cart/52166608257317:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-amber hover:bg-amber-light text-navy font-bold rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-[0_10px_40px_-10px_rgba(212,168,67,0.5)] text-lg" data-id="element-110">
                ACCEDER AL ESCUDO DE CONFIANZA AHORA
              </a>
              <p className="mt-4 text-sm text-gray-400 flex items-center gap-2" data-id="element-111">
                <ShieldCheck size={14} className="text-teal-light" data-id="element-112" />
                Descarga inmediata en PDF
              </p>
            </FadeIn>
          </div>

          <div className="order-1 md:order-2 flex justify-center md:justify-end" data-id="element-113">
            <FadeIn direction="left" delay={0.2} data-id="element-114">
              <div className="relative w-full max-w-md" data-id="element-115">
                <div className="absolute inset-0 bg-amber rounded-2xl transform rotate-3 scale-105 opacity-20 blur-lg" data-id="element-116"></div>
                <img src="https://cdn.magicpatterns.com/uploads/gbPfC8fCK5mNeKSZVwEg93/ESCUDO_DE_CONFIANZA.png" alt="Portada del Ebook Escudo de Confianza" className="relative z-10 w-full rounded-xl shadow-2xl border border-white/10" data-id="element-117" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}